/*
 * Author: Harper Yan
 * File Created: Friday, 24-07-19 01:39 pm
 * Last Modified: Monday, 25-06-30 03:40 pm, by Ben Zhao
 */

import IllusActivateCard from './ActivateCard';
import IllusAlert from './Alert';
import IllusAvatar from './Avatar';
import IllusBgAggregate from './BgAggregate';
import IllusBgCard from './BgCard';
import IllusBgDollar from './BgDollar';
import IllusCalendar from './Calendar';
import IllusCard from './Card';
import IllusCoin from './Coin';
import IllusEmptyData from './EmptyData';
import IllusErrorFlag from './ErrorFlag';
import IllusFail from './Fail';
import IllusFiatCoin from './FiatCoin';
import IllusGift from './Gift';
import IllusGiftPink from './GiftPink';
import IllusGoldCoin from './GoldCoin';
import IllusGoogle from './Google';
import IllusMining, { MiningNormal as IllusMiningNormal } from './Mining';
import IllusMyInfo from './MyInfo';
import IllusRebate, { RebateNormal as IllusRebateNormal } from './Rebate';
import IllusRecord from './Record';
import { ReferralBox as IllusReferralBox } from './ReferralBox';
import { ReferralCoin as IllusReferralCoin } from './ReferralCoin';
import IllusReferralGift from './ReferralGift';
import { ReferralNormal as IllusReferralNormal } from './ReferralNormal';
import { ReferralUser as IllusReferralUser } from './ReferralUser';
import IllusReward from './Reward';
import IllusScan from './Scan';
import IllusService from './Service';
import IllusSilverCoin from './SilverCoin';
import {
  StatusFailedV2 as IllusStatusFailedV2,
  StatusPending as IllusStatusPending,
  StatusPendingV2 as IllusStatusPendingV2,
  StatusSuccess as IllusStatusSuccess,
  StatusSuccessV2 as IllusStatusSuccessV2,
} from './Status';
import IllusSuccess from './Success';
import IllusTinyCube from './TinyCube';

export const svgs = {
  IllusScan,
  IllusMyInfo,
  IllusCard,
  IllusRecord,
  IllusGift,
  IllusEmptyData,
  IllusCalendar,
  IllusActivateCard,
  IllusGoogle,
  IllusSuccess,
  IllusFail,
  IllusService,
  IllusAvatar,
  IllusMining,
  IllusReward,
  IllusCoin,
  IllusGoldCoin,
  IllusMiningNormal,
  IllusSilverCoin,
  IllusBgDollar,
  IllusBgCard,
  IllusBgAggregate,
  IllusTinyCube,
  IllusRebate,
  IllusRebateNormal,
  IllusAlert,
  IllusStatusPending,
  IllusStatusSuccess,
  IllusErrorFlag,
  IllusStatusPendingV2,
  IllusStatusSuccessV2,
  IllusStatusFailedV2,
  IllusFiatCoin,
  IllusReferralNormal,
  IllusReferralCoin,
  IllusReferralBox,
  IllusReferralUser,
  IllusGiftPink,
  IllusReferralGift,
};

export type IllustrationType = keyof typeof svgs;
